import type { ReactNode } from 'react';
import { createContext } from 'react';

import { IP_FILTERING_SCOPE } from './types';

export const IpFilteringScopeContext = createContext({
  scope: IP_FILTERING_SCOPE.ORGANIZATION,
});

export const IpFilteringScopeProvider = ({ scope, children }: { scope: IP_FILTERING_SCOPE; children: ReactNode }) => {
  return <IpFilteringScopeContext.Provider value={{ scope }}>{children}</IpFilteringScopeContext.Provider>;
};
